export default __webpack_public_path__ + "45d2cd1b0620edc2adf9db2b117b1862.svg";